import { GAME_LOL_RANK_COLORS } from "@/game-lol/constants/constants.mjs";

export function translateLolRankedTier(t, tier) {
  switch (String(tier).toLowerCase()) {
    case "iron":
      return t("lol:ranks.iron", "Iron");
    case "bronze":
      return t("lol:ranks.bronze", "Bronze");
    case "silver":
      return t("lol:ranks.silver", "Silver");
    case "gold":
      return t("lol:ranks.gold", "Gold");
    case "platinum":
      return t("lol:ranks.platinum", "Platinum");
    case "emerald":
      return t("lol:ranks.emerald", "Emerald");
    case "diamond":
      return t("lol:ranks.diamond", "Diamond");
    case "master":
      return t("lol:ranks.master", "Master");
    case "grandmaster":
      return t("lol:ranks.grandmaster", "Grandmaster");
    case "challenger":
      return t("lol:ranks.challenger", "Challenger");
    default:
      return t("common:ranks.unranked", "Unranked");
  }
}

const map = { I: 1, II: 2, III: 3, IV: 4 };
export const convertRankFromRomanToNumber = (rank) => map[rank];

export const convertRankFromNumberToRoman = (rank) =>
  Object.keys(map).find((key) => map[key] === rank);

export function getRankColor(tier) {
  return tier ? GAME_LOL_RANK_COLORS[tier]?.text : "var(--shade3)";
}
